import AddNonHRMSEmployee from "../AddNonHRMSEmployee/AddNonHRMSEmployee";
import classes from "./EditNonHRMSEmployee.module.css";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import UTurnLeftIcon from "@mui/icons-material/UTurnLeft";

const EditNonHRMSEmployee = (props) => {
  const {
    handleSelectedOracleId,
    oracleOrExtEmpId,
    firstName,
    lastName,
    className,
  } = props;

  return (
    <div className={className}>
      <div className={classes.headerContainer}>
        <Button
          variant="contained"
          startIcon={
            <UTurnLeftIcon
              sx={{
                transform: "rotate(90deg)",
              }}
            />
          }
          onClick={() => handleSelectedOracleId(false, null)}
          sx={{
            textTransform: "none",
            backgroundColor: "#3299ff",
            color: "white",
            borderRadius: "8px",
          }}
        >
          Return to Search Results
        </Button>
      </div>
      <p className={classes.text + " " + classes.headerText}>
        Edit Non HRMS Employee &nbsp; - &nbsp;{firstName} {lastName}
      </p>
      <AddNonHRMSEmployee oracleOrExtEmpId={oracleOrExtEmpId} />
    </div>
  );
};

EditNonHRMSEmployee.propTypes = {
  handleSelectedOracleId: PropTypes.func.isRequired,
  oracleOrExtEmpId: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default EditNonHRMSEmployee;
